export default __webpack_public_path__ + "static/media/mg.7160213b.svg";